// Auto-generated file

import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  "login-email-verification": lazy(() => import("@/screens/login-email-verification")),
  "login-id": lazy(() => import("@/screens/login-id")),
  "login-password": lazy(() => import("@/screens/login-password")),
  "mfa-begin-enroll-options": lazy(
    () => import("@/screens/mfa-begin-enroll-options")
  ),
  "mfa-country-codes": lazy(() => import("@/screens/mfa-country-codes")),
  "mfa-email-challenge": lazy(() => import("@/screens/mfa-email-challenge")),
  "mfa-login-options": lazy(() => import("@/screens/mfa-login-options")),
  "mfa-otp-challenge": lazy(() => import("@/screens/mfa-otp-challenge")),
  "mfa-otp-enrollment-code": lazy(() => import("@/screens/mfa-otp-enrollment-code")),
  "mfa-otp-enrollment-qr": lazy(() => import("@/screens/mfa-otp-enrollment-qr")),
  "mfa-phone-challenge": lazy(() => import("@/screens/mfa-phone-challenge")),
  "mfa-phone-enrollment": lazy(() => import("@/screens/mfa-phone-enrollment")),
  "mfa-recovery-code-challenge": lazy(
    () => import("@/screens/mfa-recovery-code-challenge")
  ),
  "mfa-recovery-code-challenge-new-code": lazy(
    () => import("@/screens/mfa-recovery-code-challenge-new-code")
  ),
  "mfa-recovery-code-enrollment": lazy(
    () => import("@/screens/mfa-recovery-code-enrollment")
  ),
  "mfa-sms-challenge": lazy(() => import("@/screens/mfa-sms-challenge")),
  "mfa-sms-enrollment": lazy(() => import("@/screens/mfa-sms-enrollment")),
  "mfa-sms-list": lazy(() => import("@/screens/mfa-sms-list")),
  "mfa-voice-challenge": lazy(() => import("@/screens/mfa-voice-challenge")),
  "mfa-voice-enrollment": lazy(() => import("@/screens/mfa-voice-enrollment")),
  "mfa-webauthn-platform-challenge": lazy(
    () => import("@/screens/mfa-webauthn-platform-challenge")
  ),
  "mfa-webauthn-enrollment-success": lazy(
    () => import("@/screens/mfa-webauthn-enrollment-success")
  ),
  "mfa-webauthn-error": lazy(() => import("@/screens/mfa-webauthn-error")),
  "mfa-webauthn-platform-enrollment": lazy(
    () => import("@/screens/mfa-webauthn-platform-enrollment")
  ),
  "phone-identifier-enrollment": lazy(() => import("@/screens/phone-identifier-enrollment")),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-email": lazy(() => import("@/screens/reset-password-email")),
  "reset-password-error": lazy(() => import("@/screens/reset-password-error")),
  "reset-password-request": lazy(() => import("@/screens/reset-password-request")),
  "reset-password-success": lazy(() => import("@/screens/reset-password-success")),
  "signup-id": lazy(() => import("@/screens/signup-id")),
  "signup-password": lazy(() => import("@/screens/signup-password"))
};

export const getScreenComponent = (
  screenName: string | undefined
): React.ComponentType | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
